import { ShoppingBag, ChefHat, Truck, Megaphone, Users, DollarSign, Brain } from "lucide-react";

export const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_08f655cb-8b91-4c06-80bd-b94d5f4523ca/artifacts/kxmzqj5h_ChatGPT%20Image%2027%20de%20fev.%20de%202026%2C%2001_06_03.png";

export const IMAGES = {
  hero: "https://static.prod-images.emergentagent.com/jobs/28b97f98-d2b7-4af4-8918-8586df468537/images/e64ad196bbf00bc3576b1ee427acb1855e0d9eff27e42790c7824196b39a743b.png",
  workflow: "https://static.prod-images.emergentagent.com/jobs/399408c8-e69e-4bd0-a97a-9d3151f5ad84/images/c481377838e5b7de3cdc39db41be6748759eb962e9845446b1acc42df3e420a6.png",
  aiVisual: "https://static.prod-images.emergentagent.com/jobs/399408c8-e69e-4bd0-a97a-9d3151f5ad84/images/35cf48acbc78611082ba993f08e8601f74146cc9214d5625be0aa927f3a98640.png",
};

export const AVATARS = {
  carlos: "https://static.prod-images.emergentagent.com/jobs/0b70d63e-df4a-488a-9b2c-c49f711a3313/images/e2bed5bc3f8f48aa2afd3cdf91ac162da64b855060f6cc9b043e08265ba82469.png",
  ana: "https://static.prod-images.emergentagent.com/jobs/0b70d63e-df4a-488a-9b2c-c49f711a3313/images/f0c30c62075ea7c14dab0a91b1214ae950e1ce48754e6c4bc573262dd0ac67d5.png",
  miguel: "https://static.prod-images.emergentagent.com/jobs/0b70d63e-df4a-488a-9b2c-c49f711a3313/images/6e01c08d89a6ffdaaf8f231337bb86b2807c9cd88a157200ac7286813f88452d.png",
};

export const BENEFIT_ICONS = [ShoppingBag, ChefHat, Truck, Megaphone, Users, DollarSign, Brain];
